module.exports = __webpack_public_path__ + "static/media/gamegos.c09d1fe9.svg";